
import React, {useRef, Component, useEffect, useState } from 'react';
import Navigator from 'media-stream-library'
import socketIo from 'socket.io';

class Screenshare extends React.Component {
    constructor(){
      super();
      this.handleLoad = this.handleLoad.bind(this);
      this.state = {
          videoRef: null
      };
    }

    componentDidMount() {
       window.addEventListener('load', this.handleLoad);
    }
   
    componentWillUnmount() { 
      window.removeEventListener('load', this.handleLoad)  
    }
   
    handleLoad() {
    }

    CAPTURE_OPTIONS = {
      audio: false,
      video: true
    };

    setupServer = () => {

    }

    getMediaDevices = (e) => {
      console.log(navigator.mediaDevices.getDisplayMedia());
      //this.setState({videoRef: navigator.mediaDevices.getDisplayMedia()});

    }

    getVideoAudioStream = async(e) => {
      //let quality = this.settings.params?.quality;
      //if (quality) quality = parseInt(quality);
      const myNavigator = await navigator.mediaDevices.getDisplayMedia();
      const container = document.getElementById('videoContainer');
      const video = document.createElement('video');
      video.srcObject = myNavigator;
      video.autoplay=true;
      container.append(video);

      const hide = document.getElementById('devices');
      hide.style.display = "none";
      return video;
    }

    testRobot = () =>{
      // Get mouse position.
      let robot = require("robotjs");
      console.log(robot.getPixelColor(0, 0));
    }

    render(){
        return (
          <div className="App" onLoad={this.setupServer}>
            <header className="App-header">
              <button id="devices" onClick={this.getVideoAudioStream}>Devices</button>
              <div id="videoContainer"></div>
              <button id="test" onClick={this.testRobot}>TestClick</button>
            </header>
          </div>
        );
      }
}

export default Screenshare;